import * as yup from 'yup';

export const initialValues = {
    file: '',
};

export const validationSchema = yup.object({});
